import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TableColumnInterface } from '../table.interface';

@Component({
  selector: 'app-table-footer',
  templateUrl: './table-footer.component.html',
  styleUrls: ['./table-footer.component.scss']
})
export class TableFooterComponent implements OnInit {

  @Input()
  hasViewSelector: boolean;

  @Input()
  hasDisplayDensity: boolean;

  @Input()
  hasColumnSelector = false;

  @Input()
  columnInfo: TableColumnInterface[];

  @Input()
  defaultSortColumnName: string;

  @Input()
  internationalization: any;

  @Input()
  bpID: string;

  @Output()
  displayDensityEmitter = new EventEmitter();

  @Output()
  viewSelectorEmitter = new EventEmitter();

  @Output()
  columnSelectorEmitter = new EventEmitter();

  constructor() { }

  ngOnInit(): void { }

  setDisplayDensity(event: string): void {
    this.displayDensityEmitter.emit(event);
  }

  emitTableView(view: string): void {
    this.viewSelectorEmitter.emit(view);
  }

  emitSelectedColumns(columns: any[]): void {
    this.columnSelectorEmitter.emit(columns);
  }

}